import Component from "flarum/common/Component";
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import listItems from 'flarum/common/helpers/listItems';
import username from 'flarum/common/helpers/username';
import { formatDistanceToNow } from "date-fns";
import { enUS, it, de, fr } from "date-fns/locale";
export default class UserWelcomeBox extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view(vnode) {
    const user = app.session.user;
    const userLang = app.translator.getLocale();
    const SettingsLink = app.route('settings');
    const lastSeenAt = user == null ? void 0 : user.lastSeenAt();
    let locale;
    switch (userLang) {
      case 'it':
        locale = it;
        break;
      case 'de':
        locale = de;
        break;
      case 'fr':
        locale = fr;
        break;
      default:
        locale = enUS;
        break;
    }
    const lastSeenRelative = lastSeenAt ? formatDistanceToNow(new Date(lastSeenAt), {
      addSuffix: true,
      locale
    }) : app.translator.trans('flarum-ext-welcomebox.forum.neverSeen');
    return m("div", {
      className: "containerwb"
    }, m("div", {
      className: "backgrwb"
    }, Button.component({
      icon: 'fas fa-sign-out-alt logoutt',
      title: app.translator.trans('core.forum.header.log_out_button'),
      className: 'Dropdown-toggle Button logwbox',
      onclick: app.session.logout.bind(app.session)
    }), [m("div", null, m("a", {
      href: app.route.user(this.attrs.user)
    }, m("div", {
      className: "avatarwb"
    }, AvatarEditor.component({
      user: this.attrs.user
    })))), m("div", {
      className: "contentwb"
    }, m("div", {
      className: "textinfo"
    }, app.translator.trans('flarum-ext-welcomebox.forum.wback'), m("br", null), m("strong", null, username(this.attrs.user))), m("div", {
      className: "cont"
    }, m("div", {
      className: "circletop"
    }, m("a", {
      href: SettingsLink,
      title: app.translator.trans('core.forum.settings.title')
    }, m("i", {
      className: "menuicon fas fa-tasks"
    })), m("a", {
      href: app.route.user(this.attrs.user),
      title: app.translator.trans('flarum-ext-welcomebox.forum.tooltipProfile')
    }, m("i", {
      className: "menuicon far fa-user"
    })), m("a", {
      href: app.route.user(this.attrs.user) + '/mentions',
      title: app.translator.trans('flarum-ext-welcomebox.forum.tooltipMentions')
    }, m("i", {
      className: "menuicon fas fa-at"
    })), m("a", {
      href: app.route.user(this.attrs.user) + '/discussions',
      title: app.translator.trans('flarum-ext-welcomebox.forum.tooltipDisclist')
    }, m("i", {
      className: "menuicon far fa-list-alt"
    }))))), m("div", {
      className: "iconbadge"
    }, listItems(this.attrs.user.badges().toArray())), m("div", {
      className: "ulwb contentwb"
    }, m("li", null, m("label", {
      className: "textinfo"
    }, app.translator.trans('flarum-ext-welcomebox.forum.npost')), ":", ' ', m("strong", {
      className: "textinfo"
    }, user == null ? void 0 : user.commentCount())), m("li", null, m("label", {
      className: "textinfo"
    }, app.translator.trans('flarum-ext-welcomebox.forum.discussion')), ":", ' ', m("strong", {
      className: "textinfo"
    }, user == null ? void 0 : user.discussionCount())), lastSeenAt !== null && m("li", null, m("label", {
      className: "textinfo"
    }, app.translator.trans('flarum-ext-welcomebox.forum.lastSeen')), ":", ' ', m("strong", {
      className: "textinfo"
    }, lastSeenRelative)))]));
  }
}
flarum.reg.add('justoverclock-welcomebox', 'forum/components/UserWelcomeBox', UserWelcomeBox);